import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { ENDPOINTS } from '../constants';
import {
  ProfessionResponse,
  NationalityResponse,
  SkillsResponse,
  GenderResponse,
  ReligionResponse,
  MarriageStatusResponse,
  EducationResponse,
  CityResponse,
  City,
  Language,
  Age,
  Profession,
  Nationality,
  Skills,
  Gender,
  Religion,
  MarriageStatus,
  Education,
  State,
  StateResponse,
  LanguageResponse,
  Rating,
  RatingResponse,
} from '../models';

@Injectable({
  providedIn: 'root'
})
export class LookupmService {
  private http = inject(HttpClient);

  getProfessions(): Observable<Profession[]> {
    return this.http.get<ProfessionResponse>(ENDPOINTS.LOOKUP.PROFESSION).pipe(
      map(response => response.result)
    );
  }

  getNationalities(): Observable<Nationality[]> {
    return this.http.get<NationalityResponse>(ENDPOINTS.LOOKUP.NATIONALITY).pipe(
      map(response => response.result)
    );
  }
  getState(payload: any): Observable<State[]> {
    return this.http.post<StateResponse>(ENDPOINTS.LOOKUP.STATE, payload).pipe(
      map(response => response.result)
    );
  }
  getCities(payload: any): Observable<City[]> {
    return this.http.post<CityResponse>(ENDPOINTS.LOOKUP.CITY, payload).pipe(
      map(response => response.result)
    );
  }

  getSkills(): Observable<Skills[]> {
    return this.http.get<SkillsResponse>(ENDPOINTS.LOOKUP.SKILLS).pipe(
      map(response => response.result)
    );
  }

  getGenders(): Observable<Gender[]> {
    return this.http.get<GenderResponse>(ENDPOINTS.LOOKUP.GENDER).pipe(
      map(response => response.result)
    );
  }

  getAgeGroups(): Observable<Age[]> {
    return this.http.get<GenderResponse>(ENDPOINTS.LOOKUP.AGEGROUP).pipe(
      map(response => response.result)
    );
  }

  getReligions(): Observable<Religion[]> {
    return this.http.get<ReligionResponse>(ENDPOINTS.LOOKUP.RELIGION).pipe(
      map(response => response.result)
    );
  }

  getMarriageStatuses(): Observable<MarriageStatus[]> {
    return this.http.get<MarriageStatusResponse>(ENDPOINTS.LOOKUP.MARRIAGE_STATUS).pipe(
      map(response => response.result)
    );
  }

  getEducationLevels(): Observable<Education[]> {
    return this.http.get<EducationResponse>(ENDPOINTS.LOOKUP.EDUCATION).pipe(
      map(response => response.result)
    );
  }

  getLanguages(): Observable<Language[]> {
    return this.http.get<LanguageResponse>(ENDPOINTS.LOOKUP.LANGUAGE).pipe(
      map(response => response.result)
    );
  }
  getRating(): Observable<Rating[]> {
    return this.http.get<RatingResponse>(ENDPOINTS.LOOKUP.LANGUAGERATING).pipe(
      map(response => response.result)
    );
  }
}
